<template>
  <a v-if="banner" class="w-100" :href="banner.url" v-bind:target="banner.target ? '_blank' : ''">
    <div class="border-shadow-radius overflow-hidden">
      <div class="zoom-img">
        <v-img :src="banner.image" class="border border-shadow-radius" alt=""></v-img>
        <p class="banner-title" v-if="banner.titulo != ''">{{ banner.titulo }}</p>
        <p class="banner-button" v-if="banner.titulo != ''">CONFIRA</p>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'Banners',
  props: {
    banner: {
      type: Object,
      default: null
    }
  }
}
</script>